
    <div class="{{ inline ? 'd-inline' : 'row' }}">
        <div class="{{ inline ? 'd-inline' : 'col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6' }}">
            <span class="ml-3">Form Due At: <span class="text-primary">{{ dueAtString }}</span></span>
            <i class="fa fa-pencil text-primary hover-cursor ml-3" *ngIf="isDueDateEditable" (click)="updateRecordDate()"></i>
        </div>
    </div>
  